(ns manatee.admin.rejection-option.subs
  (:require [manatee.admin.rejection-option.app-db :as rejection-db]
            [medley.core :as medley]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::rejection-options
 (fn rejection-options
   [db _]
   (rejection-db/get-rejection-options db)))

(rf/reg-sub
 ::active-rejection-options
 (fn active-rejection-options
   [db _]
   (->>
    (rejection-db/get-rejection-options db)
    (filter (fn [ro]
              (not (:archived? ro)))))))

(rf/reg-sub
 ::select-rejection-options
 (fn active-rejection-options
   [_ [_ type medium]]
   (let [rejection-options (->> @(rf/subscribe [::rejection-options])
                                (filter (fn [o]
                                          (and (not (:archived? o))
                                               (= type (:type o))
                                               (or (nil? medium) ; A workaround for ELIT-3681
                                                   (= medium (:medium o)))))))]
     (->> (reduce (fn [col ro]
                    (conj col {:label (:label ro)
                               :value (:value ro)})) [] rejection-options)
          (sort-by :label)))))

(rf/reg-sub
 ::selected-rejection-option-id
 (fn selected-rejection-option-id
   [db _]
   (rejection-db/get-selected-rejection-option-id db)))

(rf/reg-sub
 ::selected-rejection-option
 :<- [::selected-rejection-option-id]
 :<- [::rejection-options]
 (fn selected-queue-config
   [[selected-id configs] _]
   (medley/find-first #(= selected-id
                          (:id %))
                      configs)))

(rf/reg-sub
 ::list-view?
 (fn list-view?
   [db _]
   (rejection-db/list-view? db)))
